import { observer } from "mobx-react-lite";
import "./SceneView.scss";
import { Menu, MenuProps } from "antd";

type Props = {
  menuItems: string[];
  selectedMenuItem: string;
  setSelectedMenuItem: (menuItem: string) => void;
};

type MenuItem = Required<MenuProps>["items"][number];

const ALL_SCENSES_KEY = "blings_all_scenes_key_menu";

function prepareListItems(items: string[]): MenuItem[] {
  const menuItems = items.map((item) => ({
    key: item,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        {item}
      </div>
    ),
    type: undefined,
  }));

  return menuItems;
}

const SceneView = observer(
  ({ menuItems, selectedMenuItem, setSelectedMenuItem }: Props) => {
    const selectedItem = selectedMenuItem;

    const onMenuItemClick = (e: any) => {
      setSelectedMenuItem(e.key);
    };

    const handleOnAllScenes = () => {};

    const items: MenuItem[] = prepareListItems(menuItems);

    return (
      <div className="scene-view">
        <Menu
          mode="inline"
          openKeys={[(items?.[0]?.key as string) || ""]}
          onClick={onMenuItemClick}
          onOpenChange={handleOnAllScenes}
          expandIcon={() => <div></div>}
          selectedKeys={[selectedItem || ALL_SCENSES_KEY]}
          items={items}
        />
      </div>
    );
  }
);
export default SceneView;
